export default __webpack_public_path__ + "static/media/page_of_pentacles.3afc2696.png";